import { NgIf } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NoDataAvailableComponent } from '@app/shared/components/no-data-available/no-data-available.component';
import { UserListService } from './services/user-list-service';
import { UserListParamsModel } from './user-list-params.model';
import { UserListModel } from './user-list.model';

@Component({
	selector: 'fm-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.less'],
	standalone: true,
	imports: [FormsModule, MatTableModule, MatSortModule, MatCheckboxModule, NgIf, NoDataAvailableComponent],
})
export class UserListComponent implements OnInit {
	@ViewChild(MatSort, { static: true }) matSort: MatSort;
	@ViewChild('usersList') formUsersList: NgForm;
	columnsToDisplay: string[] = ['UserName', 'FullName', 'Selected'];
	dataSource = new MatTableDataSource<any>();
	allUsersSelected = false;
	selectedDesc: string;
	isDataLoaded = false;

	constructor(
		private readonly userListService: UserListService,
		private readonly dialogRef: MatDialogRef<UserListComponent>,
		@Inject(MAT_DIALOG_DATA) public data: UserListParamsModel
	) {}

	ngOnInit(): void {
		//Hack added to prevent "Expression has changed after it was checked." error with loading component.
		//Only occurs with Modals, seems like an Angular bug
		setTimeout(() => {
			this.loadUsers();
		});
	}

	checkAllUsers(): void {
		this.dataSource.data.forEach((i) => {
			i.Selected = this.allUsersSelected;
		});
		this.formUsersList.form.markAsDirty();
		this.updateSelectedDisplay();
	}

	checkIfAllUsersSelected(): void {
		this.allUsersSelected = this.dataSource.data && this.dataSource.data.length > 0 && this.dataSource.data.every((e) => e.Selected === true);
		this.updateSelectedDisplay();
	}

	updateSelectedDisplay(): void {
		const selectCount = this.dataSource.data.filter((f) => f.Selected === true).length;
		this.selectedDesc = `${selectCount} selected out of ${this.dataSource.data.length}`;
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onSave(): void {
		this.dialogRef.close(this.dataSource.data);
	}

	private loadUsers(): void {
		this.isDataLoaded = false;
		this.userListService.getUsers(this.data.Account).subscribe((data) => {
			this.dataSource = new MatTableDataSource<UserListModel>(data);
			this.dataSource.sort = this.matSort;
			this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
			this.isDataLoaded = true;
			this.checkIfAllUsersSelected();
		});
	}

	private sortingDataAccessor(data: any, sortHeaderId: string): string | number {
		if (typeof data[sortHeaderId] === 'string') {
			if (!isNaN(data[sortHeaderId])) {
				return parseFloat(data[sortHeaderId]);
			}

			return data[sortHeaderId].toLocaleLowerCase();
		}
		return data[sortHeaderId];
	}
}
